import { createSelector } from 'reselect';

import type { AppState } from '../../store/types';

const getViews = (state: AppState) => state.entities.metadata_views;
const getViewId = (_state: AppState, viewId: string) => viewId;

export const selectBlockFieldNames = createSelector(
  [getViews, getViewId],
  (views, viewId): string[] => {
    const view = views[viewId];
    if (!view) {
      return [];
    }
    return view.view_fields
      .filter((field) => field.is_block_field)
      .map((field) => field.name);
  },
);

export const selectWarningFieldNames = createSelector(
  [getViews, getViewId],
  (views, viewId): string[] => {
    const view = views[viewId];
    if (!view) {
      return [];
    }
    return view.view_fields
      .filter((field) => field.is_warning_field)
      .map((field) => field.name);
  },
);
